import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./AddProjectSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";

import AddProjectStepOne from "./AddProjectSteps/AddProjectStepOne";
import AddProjectStepTwo from "./AddProjectSteps/AddProjectStepTwo";
import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { projectPriority } from "./lib/utils";

const AddProjectForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);
  const [workers, setWorkers] = useState([]);
  useEffect(() => {
    if (update) {
      setInitialValues({
        ..._initialValues,
        projectClient: _initialValues?.projectClient?.uuid
          ? { value: _initialValues?.projectClient?.uuid }
          : null,
        projectManager: _initialValues?.projectManager?.uuid
          ? { value: _initialValues?.projectManager?.uuid }
          : null,
        projectPriority: _initialValues?.projectPriority
          ? { value: _initialValues?.projectPriority }
          : null,
        projectType: _initialValues?.projectType?.uuid
          ? { value: _initialValues?.projectType?.uuid }
          : null,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  const fetchData = async () => {
    const workersFetch = GlobalAuthFetch({ path: "/worker/all" });

    const [workersPayload] = await Promise.all([workersFetch]);

    setWorkers(workersPayload?.payload?.data);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, { ...props, initialValues })}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={false}
    >
      {(formProps) => {
        return (
          <>
            <form
              id={props.formName}
              onSubmit={formProps.handleSubmit}
              className="AddProjectForm"
            >
              <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={step}
                onChangeIndex={(index) => setStep(index)}
              >
                <AddProjectStepOne
                  {...formProps}
                  {...props}
                  workers={workers}
                />
                <AddProjectStepTwo
                  {...formProps}
                  {...props}
                  workers={workers}
                />
              </SwipeableViews>
            </form>
          </>
        );
      }}
    </Form>
  );
};

export default AddProjectForm;
